(function () {
    function getVariantData(wrapper) {
      const selected = wrapper.querySelector('.prod_opt_selection');

      if (!selected) return null;

      return {
        id: selected.dataset.variantId,
        inventory: parseInt(selected.dataset.inventory, 10),
      };
    }

    function updateButton(wrapper) {
      const button = wrapper.querySelector('.custom-upsell__add');
      const variantData = getVariantData(wrapper);

      if (!button || !variantData) return;

      const { id, inventory } = variantData;

      button.dataset.variantId = id;
      button.dataset.inventory = inventory;

      if (inventory < 1) {
        button.disabled = true;
        button.textContent = 'Sold out';
      } else {
        button.disabled = false;
        button.textContent = 'Add to cart';
      }
    }

    function closeAllDropdowns(except = null) {
      document.querySelectorAll('.custom-upsell__options.is-open').forEach((dropdown) => {
        if (dropdown !== except) {
          dropdown.classList.remove('is-open');
        }
      });
    }

    /* INIT — FIRST AVAILABLE VARIANT */
    function initUpsells() {
      document.querySelectorAll('.custom-upsell').forEach((wrapper) => {
        const selected = wrapper.querySelector('.prod_opt_selection');

        /*
         * Only products with variants need initialization.
         * Default variant products already have their
         * variant ID directly on the Add to cart button.
         */
        if (selected && !selected.dataset.variantId) {
          const firstOption = wrapper.querySelector('.custom-upsell__option:not(.is-soldout)');

          if (!firstOption) return;

          selected.dataset.variantId = firstOption.dataset.variantId;
          selected.dataset.inventory = firstOption.dataset.inventory;
        }

        updateButton(wrapper);
      });
    }

    document.addEventListener('DOMContentLoaded', () => {
      initUpsells();
      hideUpsellIfEmpty();
    });

    /* =========================================================
     ADD PRODUCT TO CART
     ========================================================= */

    function addUpsellToCart(variantId, button = null, option = null) {
      if (!variantId) return;

      /*
       * Get inventory from either:
       * - Add button
       * - Variant option
       */
      const inventorySource = button || option;

      const inventory = parseInt(inventorySource?.dataset.inventory, 10);

      if (inventory < 1) return;

      /*
       * Disable button while adding
       */
      if (button) {
        button.disabled = true;
        button.textContent = 'Adding…';
      }

      /*
       * Prevent clicking the same variant multiple times
       */
      if (option) {
        option.classList.add('is-adding');
        option.style.pointerEvents = 'none';
      }

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',

        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },

        body: JSON.stringify({
          id: variantId,
          quantity: 1,

          /*
           * Horizon cart sections
           */
          sections: ['cart-drawer', 'cart-icon-bubble'],

          sections_url: window.location.pathname,
        }),
      })
        .then((response) => {
          if (!response.ok) {
            return response.json().then((error) => {
              throw error;
            });
          }

          return response.json();
        })

        .then((state) => {
          /*
           * Horizon CartUpdateEvent
           */
          import('@theme/events').then(({ CartUpdateEvent }) => {
            const event = new CartUpdateEvent(state, 'custom-upsell', {
              itemCount: state.item_count,
              source: 'upsell',
              variantId: variantId,
              sections: state.sections || {},
            });

            document.dispatchEvent(event);
          });

          /*
           * Default variant button
           */
          if (button) {
            button.textContent = 'Added';

            setTimeout(() => {
              button.disabled = false;
            }, 1000);
          }

          /*
           * Variant option
           */
          if (option) {
            option.classList.remove('is-adding');
            option.style.pointerEvents = '';

            /*
             * Close dropdown after adding
             */
            const dropdown = option.closest('.custom-upsell__options');

            if (dropdown) {
              dropdown.classList.remove('is-open');
            }
          }

          hideUpsellIfEmpty();
        })

        .catch((error) => {
          console.error('Upsell add to cart error:', error);

          /*
           * Reset default variant button
           */
          if (button) {
            button.disabled = false;
            button.textContent = 'Add to cart';
          }

          /*
           * Reset variant option
           */
          if (option) {
            option.classList.remove('is-adding');
            option.style.pointerEvents = '';
          }
        });
    }

    /* =========================================================
     TOGGLE DROPDOWN
     ========================================================= */

    document.addEventListener('click', function (e) {
      const trigger = e.target.closest('.prod_opt_selection');

      if (!trigger) return;

      const dropdown = trigger.nextElementSibling;

      if (!dropdown) return;

      const isOpen = dropdown.classList.contains('is-open');

      closeAllDropdowns();

      if (!isOpen) {
        dropdown.classList.add('is-open');
      }
    });

    /* =========================================================
     VARIANT OPTION SELECT
     
     Select variant + DIRECTLY ADD TO CART
     ========================================================= */

    document.addEventListener('click', function (e) {
      const option = e.target.closest('.custom-upsell__option');

      if (!option) return;

      /*
       * Don't allow sold-out variants
       */
      if (option.classList.contains('is-soldout')) {
        return;
      }

      /*
       * Prevent double click while adding
       */
      if (option.classList.contains('is-adding')) {
        return;
      }

      const wrapper = option.closest('.custom-upsell');

      if (!wrapper) return;

      const display = wrapper.querySelector('.prod_opt_selection');

      const dropdown = option.closest('.custom-upsell__options');

      const variantId = option.dataset.variantId;

      const inventory = parseInt(option.dataset.inventory, 10);

      if (!variantId || inventory < 1) {
        return;
      }

      /*
       * Update selected variant
       */
      if (display) {
        display.dataset.variantId = variantId;
        display.dataset.inventory = inventory;
      }

      /*
       * Close dropdown immediately
       */
      if (dropdown) {
        dropdown.classList.remove('is-open');
      }

      /*
       * Add selected variant directly to cart
       */
      addUpsellToCart(variantId, null, option);
    });

    /* =========================================================
     OUTSIDE CLICK — CLOSE ALL
     ========================================================= */

    document.addEventListener('click', function (e) {
      if (e.target.closest('.custom-upsell__dropdown') || e.target.closest('.prod_opt_selection')) {
        return;
      }

      closeAllDropdowns();
    });

    /* =========================================================
     DEFAULT VARIANT — ADD TO CART
     ========================================================= */

    document.addEventListener('click', function (e) {
      const button = e.target.closest('.custom-upsell__add');

      if (!button) return;

      e.preventDefault();

      if (button.disabled) return;

      const variantId = button.dataset.variantId;

      const inventory = parseInt(button.dataset.inventory, 10);

      if (!variantId || inventory < 1) return;

      /*
       * Add default variant directly
       */
      addUpsellToCart(variantId, button, null);
    });

    /* =========================================================
     HIDE UPSELL WRAPPER
     ========================================================= */

    function hideUpsellIfEmpty() {
      const upsellWrap = document.querySelector('.custom_upsells_item_wrap');

      const mainWrap = document.querySelector('.cart_upsell_main_wrap');

      if (!upsellWrap || !mainWrap) return;

      if (!upsellWrap.children.length) {
        mainWrap.style.display = 'none';
      }
    }
  })();